import { CreatePayrollResultResultConceptItemsInput } from 'generated/resources/graphql'
import isEmpty from 'lodash/isEmpty'

import type {
  ImportData,
  ImportEmployeeConcept,
} from 'modules/payroll_bundle/lib/PayrollResultContext'

import { LabelToConceptId } from './types'

const calculateResultConceptItems = (
  importData: ImportData[],
  employeesSelected: Set<string>,
  labelToConceptId: LabelToConceptId
) => {
  return importData.flatMap((data) => {
    const employee_id = data.employee_id
    if (!employee_id || !employeesSelected.has(data.id)) {
      return []
    }
    const concepts: ImportEmployeeConcept[] = data.concepts

    return concepts
      .filter((concept) => !isEmpty(concept.value))
      .reduce((acc: CreatePayrollResultResultConceptItemsInput[], concept) => {
        const payrollConceptId = labelToConceptId[concept.label]

        return payrollConceptId
          ? [
              ...acc,
              {
                employeeId: employee_id,
                payrollConceptId: concept.concept_id,
                amount: parseFloat(concept.value),
              },
            ]
          : acc
      }, [])
  })
}

const uniqueConceptItemsHash = (
  resultConceptItems: CreatePayrollResultResultConceptItemsInput[]
) => {
  return resultConceptItems.reduce(
    (acc: Record<string, CreatePayrollResultResultConceptItemsInput>, conceptItem) => {
      const key = `${conceptItem.employeeId}-${conceptItem.payrollConceptId}`

      const item = acc ? acc[key] : null
      if (item) {
        item.amount = Number(item.amount) + Number(conceptItem.amount)
      } else {
        acc[key] = conceptItem
      }

      return acc
    },
    {}
  )
}

export const generateResultConceptItems = (
  importData: ImportData[],
  employeesSelected: Set<string>,
  labelToConceptId: LabelToConceptId
) => {
  const resultConceptItems = calculateResultConceptItems(
    importData,
    employeesSelected,
    labelToConceptId
  )
  return Object.values(uniqueConceptItemsHash(resultConceptItems))
}
